import React from "react";
import "react-table/react-table.css";

import "./Table.scss";

export const filterString = (filter, row, column) => {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
      ? String(row[id].toString().toLowerCase()).includes(filter.value.toString().toLowerCase())
      : true;
};

export function WrappedTable(ListComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      
      this.getWrappedInstance.bind(this);
    }
    state = {
      data: this.props.data,
      pageSize: 20,
      columns: this.props.columns,
      selection: this.props.selection ? this.props.selection :[] ,
      selectAll: false
    };
    
    getWrappedInstance = () => {
      if (!this.wrappedInstance) {
        console.log("No Wrapped Instance");
      }
      else if (this.wrappedInstance.getWrappedInstance)
        return this.wrappedInstance.getWrappedInstance();
      else return this.wrappedInstance;
    };
    
    toggleSelection = (key, shift, row) => {
      /*
      Implementation of how to manage the selection state is up to the developer.
      This implementation uses an array stored in the component state.
      Other implementations could use object keys, a Javascript Set, or Redux... etc.
    */
      console.log(key);
      // start off with the existing state
      let selection = [...this.state.selection];
      const keyIndex = selection.indexOf(key);
      // check to see if the key exists
      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        selection = [
          ...selection.slice(0, keyIndex),
          ...selection.slice(keyIndex + 1)
        ];
      } else {
        // it does not exist so add it
        selection.push(key);
      }
      // update the state
      this.setState({ selection });
    };
    
    toggleAll = () => {
      const selectAll = !this.state.selectAll;
      const selection = [];
      if (selectAll) {
        const wrappedInstance = this.getWrappedInstance().checkboxTable.wrappedInstance;
        const currentRecords = wrappedInstance.resolvedData;
        
        currentRecords.forEach((item) => {
          selection.push(item.id);
        })
      }
      
      this.setState({ selectAll, selection });
    };
    
    isSelected = key => {
      /*
      Instead of passing our external selection state we provide an 'isSelected'
      callback and detect the selection state ourselves. This allows any implementation
      for selection (either an array, object keys, or even a Javascript Set object).
    */
      return this.state.selection.includes(key);
    };
    
    render() {
      
      const { isSelected, state, props, toggleAll } = this;
      const { selectAll, selection } = state;
      const checkboxProps = {
        
        selectAll,
        isSelected,
        toggleSelection: (key, shift, row) => this.toggleSelection(key, shift, row),
        toggleAll,
        selectType: "checkbox"
      };
      
      return (
          <React.Fragment>
            <ListComponent
                ref={r => (this.wrappedInstance = r)}
                selected={selection}
                checkboxProps={checkboxProps}
                {...props}
                defaultSelected= {(items) => this.setState({selection: items})}
            />
          </React.Fragment>
      );
    }
  };
}

export default WrappedTable;



// WEBPACK FOOTER //
// ./src/system/containers/Table/index.jsx